import { render } from "./FolderComponent.vue?vue&type=template&id=284f41ce"
import script from "./FolderComponent.vue?vue&type=script&lang=js"
export * from "./FolderComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__